import copy from 'copy-to-clipboard';

export const copyTable = (root: HTMLElement | null) => {
  if (!root) return;

  const table = root.querySelector('table');
  if (!table) return;

  const getText = (n: Element) =>
    (n.textContent || '').replace(/\r?\n|\r/g, ' ').trim();

  const header = Array.from(table.querySelectorAll('thead th'))
    .map(getText)
    .join('\t');

  const body = Array.from(table.querySelectorAll('tbody tr'))
    .map((tr) => Array.from(tr.querySelectorAll('td')).map(getText).join('\t'))
    .join('\r\n');

  copy(`${header}\r\n${body}`, { format: 'text/plain' });
};
